// Vue
import Vue from 'vue'
import i18n from './i18n'
import App from './App'
// 核心插件
import d2Admin from '@/plugin/d2admin'
// store
import store from '@/store/index'

// 菜单和路由设置
import router from './router'
import menuHeader from '@/menu/header'
import menuAside from '@/menu/aside'
import {
	frameInRoutes
} from '@/router/routes'


// WebSocket封装方法
import * as socketApi from './api/socket'
Vue.prototype.socketApi = socketApi

//main.js引入
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
	key: 'ccbae38908be894cf5920fb1ecb94533',  //你在高德申请的key
	plugin: ['Geocoder','AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType',
		'AMap.PolyEditor', 'AMap.CircleEditor'
	],
	v: '1.4.4'
});


window.UploadAddress = 'https://automotive.zhixiuyunfu.com/api/server/' + 'file/upload';
window.UploadExcel = 'https://automotive.zhixiuyunfu.com/api/server/business/importFileController/importExcel';
window.baseUrl = 'https://automotive.zhixiuyunfu.com/api/server/';


window.carOptions = [{
	value: '厂家名称',
	key: 'Manufacturers'
}, {
	value: '品牌名称',
	key: 'Brand'
}, {
	value: '车系',
	key: 'Series'
}, {
	value: '车型',
	key: 'Models'
}, {
	value: '销售名称',
	key: 'SalesName'
}, {
	value: '销售版本',
	key: 'SalesVarsion'
}, {
	value: '年款',
	key: 'Year'
}, {
	value: '排放标准',
	key: 'EmissionStandard'
}, {
	value: '车辆类型',
	key: 'VehicleType'
}, {
	value: '车辆级别',
	key: 'VehicleSize'
}, {
	value: '停产年份',
	key: 'IdlingYear'
}, {
	value: '进气形式',
	key: 'Induction'
}, {
	value: '燃油类型',
	key: 'FuelType'
}, {
	value: '燃油标号',
	key: 'FuelGrade'
}, {
	value: '最大马力（ps）',
	key: 'Horsepower'
}, {
	value: '最大功率（kw)',
	key: 'PowerKw'
}, {
	value: '供油方式',
	key: 'Fuellnjection'
}, {
	value: '三元催化器',
	key: 'Catalyst'
}, {
	value: '发动机描述',
	key: 'EngineDescription'
}, {
	value: '变速器描述',
	key: 'TransmissionDescription'
}, {
	value: '档位数',
	key: 'GearNumber'
}, {
	value: '转向机形式',
	key: 'Steering'
}, {
	value: '助力类型',
	key: 'PowerSteering'
}, {
	value: '驱动形式',
	key: 'DriveModel'
}, {
	value: '车身型式',
	key: 'BodyType'
}, {
	value: '油箱容积（L)',
	key: 'FuelTankCapacity'
}, {
	value: '前轮胎规格',
	key: 'FrontTyre'
}, {
	value: '后轮胎规格',
	key: 'RearTyre'
}, {
	value: '整车质保',
	key: 'WarrantyPeriod'
}, {
	value: '氙气大灯',
	key: 'HidHeadlamp'
}]
// 核心插件
Vue.use(d2Admin)

new Vue({
	router,
	store,
	i18n,
	render: h => h(App),
	created() {
		// 处理路由 得到每一级的路由设置
		this.$store.commit('d2admin/page/init', frameInRoutes)
		// 设置顶栏菜单
		this.$store.commit('d2admin/menu/headerSet', menuHeader)
		// 设置侧边栏菜单
		this.$store.commit('d2admin/menu/asideSet', menuAside)
		// 初始化菜单搜索功能
		this.$store.commit('d2admin/search/init', menuHeader)
	},
	mounted() {
		// 展示系统信息
		this.$store.commit('d2admin/releases/versionShow')
		// 用户登录后从数据库加载一系列的设置
		this.$store.dispatch('d2admin/account/load')
		// 获取并记录用户 UA
		this.$store.commit('d2admin/ua/get')
		// 初始化全屏监听
		this.$store.dispatch('d2admin/fullscreen/listen')
	}
}).$mount('#app')
